import { render, staticRenderFns } from "./HeaderInfinityContainer.vue?vue&type=template&id=546e2542&scoped=true&"
import script from "./HeaderInfinityContainer.vue?vue&type=script&lang=js&"
export * from "./HeaderInfinityContainer.vue?vue&type=script&lang=js&"
import style0 from "./HeaderInfinityContainer.vue?vue&type=style&index=0&id=546e2542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546e2542",
  null
  
)

export default component.exports